import multiLangHelpers from 'utils/multilanguage/helpers/multilanguage-helpers';
import { setSelectedLanguage } from 'utils/actions/selected-language/selected-language.actions';
import { cloneDeep } from 'lodash';
import template from './rw-language-select.html';

const mapStateToThis = ({ session, config, ui }) => {
  const { locale } = session;
  const { locales } = config;
  const { selectedLanguage } = ui;

  return {
    locale,
    locales,
    selectedLanguage,
  };
};
const mapDispatchToThis = {
  setSelectedLanguage,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux', '$scope', 'Notifications', 'gettextCatalog')
class RwLanguageSelectController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    if (!this.selectedLanguage) {
      this.setSelectedLanguage(this.locale);
    }
    this.lastSelectedLanguage = this.selectedLanguage;
  }

  $onDestroy() {
    this.unsubscribe();
  }

  checkFormValidation() {
    let formIsValid = true;
    if (this.form) {
      formIsValid = multiLangHelpers.checkFormValidation(this.form);
    }
    return formIsValid;
  }

  onLanguageChange(locale) {
    if (this.checkFormValidation()) {
      this.lastSelectedLanguage = locale;
      this.setSelectedLanguage(locale);
      this.onLanguageSelect({ locale });
    } else {
      this.selectedLanguage = this.lastSelectedLanguage;
      this.Notifications.alertWarning(this.gettextCatalog.getString('Validation failed. Please review errors.'));
    }
  }
}

export default class RwLanguageSelectComponent {
  constructor() {
    this.template = template;
    this.controller = RwLanguageSelectController;
    this.bindings = {
      form: '<',
      onLanguageSelect: '&',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/multilanguage/components/rw-language-select/rw-language-select-component.js